/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'set': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M588.8 709.818l244.364 267.637 118.69-123.346-256-256L588.8 709.82zm195.49 121.018l48.874-37.236 48.872 37.236-18.618 60.51H802.91l-18.618-60.51zM344.437 444.51l79.128 81.455L528.29 416.582 446.836 332.8c86.11-202.473-160.581-281.6-160.581-281.6-46.546-11.636-37.237 23.273-37.237 23.273 95.418 81.454 81.455 109.382 81.455 109.382-11.637 95.418-90.764 132.654-90.764 132.654-81.454 32.582-146.618-83.782-146.618-83.782-25.6-4.654-23.273 25.6-23.273 25.6C134.982 551.564 344.436 444.51 344.436 444.51zm437.528-242.036s-81.455 9.309-76.8-79.128L640 55.855 521.31 179.2l58.18 60.51s144.292 6.98 93.092 128L456.145 593.454l-41.89-6.982-246.691 256s-16.291 62.836 25.6 100.072c0 0 27.927 34.91 86.109 32.582l242.036-260.654 4.655-41.891 246.69-253.673s13.964-23.273 37.237-2.327c0 0 65.164 30.254 60.509 186.182l46.545 48.872s51.2-121.018 32.582-223.418c0-2.327 0-97.745-167.563-225.745z"/>'
  }
})
